import * as React from 'react'

function SvgTwitterLogo(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#twitter_logo_svg__twitter_logo_svg__clip0)">
        <path
          d="M14.883 2.46a.308.308 0 00.039-.444.366.366 0 00-.17-.108l-.512-.127a.315.315 0 01-.234-.386l.02-.057.285-.565a.314.314 0 00-.149-.424.349.349 0 00-.227-.02l-1.298.356a.352.352 0 01-.286-.051A3.302 3.302 0 0010.404 0C8.613 0 7.159 1.42 7.159 3.17v.228a.159.159 0 01-.143.158c-1.824.21-3.57-.697-5.452-2.814a.34.34 0 00-.331-.095.315.315 0 00-.189.266 4.696 4.696 0 00.299 3.119c.039.076.006.17-.071.215a.174.174 0 01-.098.013l-.727-.14c-.175-.025-.344.09-.37.26a.337.337 0 000 .114c.11.983.682 1.87 1.539 2.397.077.038.116.133.077.209-.012.032-.045.057-.077.076l-.344.133a.313.313 0 00-.182.412c.006.006.006.02.013.025A2.815 2.815 0 003.18 9.32c.084.031.13.12.097.202a.177.177 0 01-.097.095 7.336 7.336 0 01-2.785.527.327.327 0 00-.39.253c-.038.178.079.342.26.38A13.215 13.215 0 005.55 12a8.315 8.315 0 004.543-1.268c2.26-1.477 3.616-3.955 3.61-6.612v-.55a.31.31 0 01.116-.24l1.065-.87z"
          fill="#333"
        />
      </g>
      <defs>
        <clipPath id="twitter_logo_svg__twitter_logo_svg__clip0">
          <rect width={15} height={12} fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SvgTwitterLogo
